<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">Reporte de Cuentas Deudoras</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda</mat-label>
                <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select class="text-style" formControlName="MonedaId">
                  <mat-option class="text-style">Todos</mat-option>
                  <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label class="text-style">Fecha Movimiento Desde</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaMovimientoDesdePicker" formControlName="FechaMovimientoDesde"  (click)="fechaMovimientoDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaMovimientoDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaMovimientoDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style">Fecha Movimiento Hasta</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaMovimientoHastaPicker" formControlName="FechaMovimientoHasta"  (click)="fechaMovimientoHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaMovimientoHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaMovimientoHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

          </div>

          <hr width="100%" style="margin: 5px 0px;">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                <mat-select formControlName="ConsorcioId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadId" (selectionChange)="onDeudaFiltroUfComunidadSelect()">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
                <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                <mat-select formControlName="UnidadFuncionalId">
                  <mat-option>Ninguna</mat-option>
                  <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Usuario</mat-label>
                <input matInput formControlName="Usuario" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Documento</mat-label>
                <input matInput formControlName="NroDocumento" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Email</mat-label>
                <input matInput formControlName="MailContacto" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Celular</mat-label>
                <input matInput formControlName="MovilContacto" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

          </div>

          <hr width="100%" style="margin: 5px 0px;">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label class="text-style">Fecha Vencimiento de Control</mat-label>
                <input class="text-style" matInput [matDatepicker]="fechaVencimientoControlPicker" formControlName="FechaVencimientoControl"  (click)="fechaVencimientoControlPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoControlPicker">
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoControlPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <!-- <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
              <mat-checkbox formControlName="VerAgrupadoPorUnidadFuncional" (change)="onSearch()">Ver agrupado por {{'UnidadFuncional' | translate}}</mat-checkbox>
            </div> -->
            <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" *ngIf="searchForm.get('VerAgrupadoPorUnidadFuncional').value" style="margin-top: 20px;">
              <mat-checkbox formControlName="VerDetalleContactos" (change)="onSearch()">Ver detalle de contactos</mat-checkbox>
            </div>

          </div>

        </form>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
        <button mat-raised-button (click)="onSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isProcessing()" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <br/>

      <mat-expansion-panel [expanded]="false" [hideToggle]="false" class="zb-readonly" *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fa fa-solid fa-chart-area fa-1x" style="margin-right: 5px;"></i> Estadísticas de la Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTALES SALDOS:</b></mat-label>
              <br/>
              <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
              <ng-container *ngIf="!isStatisticsSearching">
                <mat-label *ngFor="let item of totales | keyvalue" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTALES SALDOS VENCIDOS:</b></mat-label>
              <br/>
              <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
              <ng-container *ngIf="!isStatisticsSearching">
                <mat-label *ngFor="let item of totalesVencidos | keyvalue" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <!-- GRILLA SIN DETALLE DE CONTACTOS -->
      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching && !(searchForm.get('VerDetalleContactos').value == true)">

        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
          [pageSettings]='pageSettings' [allowResizing]='true' (actionBegin)="onActionBegin($event)">
          <e-columns>
            <e-column field='Concepto' headerText='Concepto' width=150></e-column>
            <e-column field='Moneda' headerText='Moneda' width=100></e-column>
            <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70 format="N2"></e-column>
            <e-column field='SaldoVencido' headerText='Saldo Vencido' textAlign="right" width=70 format="N2"></e-column>
            <e-column headerText='Acciones' width=50>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px;" (click)="openDialogDetalleMovimientos(data)" title="Ver detalle de movimientos">
                  <i class="fa fa-search fa-1x"></i>
                </a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>

      </div>

      <!-- GRILLA CON DETALLE DE CONTACTOS -->
      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching && searchForm.get('VerDetalleContactos').value == true">

        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
          [pageSettings]='pageSettings' [allowResizing]='true' (actionBegin)="onActionBegin($event)">
          <e-columns>
            <e-column field='Concepto' headerText='Concepto' width=120></e-column>

            <e-column headerText='Nombre' width=90>
              <ng-template #template let-data>
                {{data.Contactos != null && data.Contactos.length > 0 ? data.Contactos[0].Nombre : ''}}
              </ng-template>
            </e-column>
            <e-column headerText='Mail' width=80>
              <ng-template #template let-data>
                {{data.Contactos != null && data.Contactos.length > 0 ? data.Contactos[0].MailContacto : ''}}
              </ng-template>
            </e-column>
            <e-column headerText='Móvil' width=70>
              <ng-template #template let-data>
                {{data.Contactos != null && data.Contactos.length > 0 ? data.Contactos[0].MovilContacto : ''}}
              </ng-template>
            </e-column>
            <e-column headerText='Detalle' width=100>
              <ng-template #template let-data>
                {{data.Contactos != null && data.Contactos.length > 0 ? data.Contactos[0].Detalle : ''}}
              </ng-template>
            </e-column>

            <e-column field='Moneda' headerText='Moneda' width=60></e-column>
            <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70 format="N2"></e-column>
            <e-column field='SaldoVencido' headerText='Saldo Vencido' textAlign="right" width=70 format="N2"></e-column>
            <e-column headerText='Acciones' width=80>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px;" (click)="openDialogDetalleMovimientos(data, false)" title="Ver detalle de movimientos">
                  <i class="fa fa-search fa-1x"></i>
                </a>
                <a style="cursor: pointer; margin-right: 5px;" (click)="openDialogDetalleMovimientos(data, true)" *ngIf="data.Contactos != null && data.Contactos.length > 1"
                  [title]="'Ver los ' + data.Contactos.length + ' contactos relacionados'">
                  <i class="fa fa-users fa-1x"></i>
                </a>
                <a style="cursor: pointer; margin-right: 5px;" (click)="enviarDetalleDeuda(data, 'PDF')" title="Descargar detalle de deuda">
                  <i class="fa fa-file fa-1x"></i>
                </a>
                <a style="cursor: pointer; margin-right: 5px;" (click)="enviarDetalleDeuda(data, 'MAIL')" *ngIf="data.PuedeEnviarCorreoDeuda"
                  title="Enviar detalle de deuda al mail del contacto">
                  <i class="fa fa-envelope fa-1x"></i>
                </a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>

      </div>

    </ng-container>

  </mat-card-content>
</mat-card>
